/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} When_You_Buy_An_Item_It_WillInputs */

const en_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you buy an item, it will appear here.`)
};

const es_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando compres un artículo, aparecerá aquí.`)
};

const fr_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque vous achetez un article, il apparaîtra ici.`)
};

const de_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du einen Artikel kaufst, wird er hier angezeigt.`)
};

const ja_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品を購入すると、ここに表示されます。`)
};

const zh_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当您购买商品时，它将显示在这里。`)
};

const ar_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عندما تشتري عنصرًا، سيظهر هنا.`)
};

const id_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat Anda membeli item, item tersebut akan muncul di sini.`)
};

const it_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando acquisti un articolo, apparirà qui.`)
};

const ru_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда вы купите товар, он появится здесь.`)
};

const pt_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você comprar um item, ele aparecerá aqui.`)
};

const ko_when_you_buy_an_item_it_will = /** @type {(inputs: When_You_Buy_An_Item_It_WillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품을 구매하면 이곳에 표시됩니다.`)
};

/**
* | output |
* | --- |
* | "When you buy an item, it will appear here." |
*
* @param {When_You_Buy_An_Item_It_WillInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const when_you_buy_an_item_it_will = /** @type {((inputs?: When_You_Buy_An_Item_It_WillInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<When_You_Buy_An_Item_It_WillInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_when_you_buy_an_item_it_will(inputs)
	if (locale === "es") return es_when_you_buy_an_item_it_will(inputs)
	if (locale === "fr") return fr_when_you_buy_an_item_it_will(inputs)
	if (locale === "de") return de_when_you_buy_an_item_it_will(inputs)
	if (locale === "ja") return ja_when_you_buy_an_item_it_will(inputs)
	if (locale === "zh") return zh_when_you_buy_an_item_it_will(inputs)
	if (locale === "ar") return ar_when_you_buy_an_item_it_will(inputs)
	if (locale === "id") return id_when_you_buy_an_item_it_will(inputs)
	if (locale === "it") return it_when_you_buy_an_item_it_will(inputs)
	if (locale === "ru") return ru_when_you_buy_an_item_it_will(inputs)
	if (locale === "pt") return pt_when_you_buy_an_item_it_will(inputs)
	return ko_when_you_buy_an_item_it_will(inputs)
});